module.exports = __webpack_public_path__ + "static/trash-disabled.f094e62bdd169e783849b6af23e8d776.svg";